import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const GdaScore: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const mathML = createMathML(`
    <mrow>
      <msub>
        <mi>S</mi>
        <mrow>
          <mi mathvariant="italic">GDA</mi>
        </mrow>
      </msub>
      <mo>=</mo>
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">C</mi>
        </mrow>
      </msub>
      <mo>+</mo>
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">T</mi>
        </mrow>
      </msub>
      <mo>+</mo>
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">I</mi>
        </mrow>
      </msub>
      <mo>+</mo>
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">M</mi>
        </mrow>
      </msub>
      <mo>+</mo>
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">L</mi>
        </mrow>
      </msub>
    </mrow>
  `);

  return <MathMLRenderer mathML={mathML} className={className} style={style} />;
};